export class BaseResponse {
  public Status!: number;
  public Message!: string;
  public UserId!: number;
  public ErrorMessage!: string;
}